import script from "./QuizComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuizComponent.vue?vue&type=script&lang=ts&setup=true"

import "./QuizComponent.vue?vue&type=style&index=0&id=0ad98a9f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad98a9f"]])

export default __exports__